import { Box, Tab, Tabs, Typography } from '@mui/material'
import { Link, useSearchParams } from 'react-router-dom'

import { AppointmentReportTab } from './AppointmentReportTab.tsx'
import { ScoutReportTab } from './ScoutReportTab.tsx'

const REPORT_TABS = [
  { key: 'appointments', label: 'Appointment report', Component: AppointmentReportTab },
  { key: 'scouts', label: 'Scout report', Component: ScoutReportTab },
]

export const ReportsPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const activeTab = REPORT_TABS.find(tab => tab.key === searchParams.get('tab')) ?? REPORT_TABS[0]

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#2D3748',
            fontSize: '1.5rem',
            mb: 0.5,
          }}
        >
          Reports
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#718096',
            fontSize: '1rem',
          }}
        >
          Analytics and insights for project management
        </Typography>
      </Box>
      <Tabs value={activeTab.key} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        {REPORT_TABS.map(tab => (
          <Tab
            key={tab.key}
            value={tab.key}
            label={tab.label}
            component={Link}
            to={`?tab=${tab.key}`}
          />
        ))}
      </Tabs>
      <activeTab.Component key={activeTab.key} />
    </Box>
  )
}
